import React, { ReactNode } from 'react'
import { Element, Table } from 'react-bulma-components'

const weekDays = [1, 2, 3, 4, 5, 6, 0] as const
const weekDayNames = ['Di.', 'Lu.', 'Ma.', 'Me.', 'Je.', 'Ve.', 'Sa.'] as const

export type IsoWeekDay = (typeof weekDays)[number]

export interface WeeksListHeaderProps {
  left?: (isoWeekDay: IsoWeekDay | null) => ReactNode | string
  right?: (isoWeekDay: IsoWeekDay | null) => ReactNode | string
}

export const WeeksList = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <Table bordered size="fullwidth">
      <tbody>
        <>{children}</>
      </tbody>
    </Table>
  )
}

const Header = ({ left, right }: WeeksListHeaderProps) => {
  return (
    <>
      <tr>
        <Element renderAs="td" textWeight="bold">
          Semaine
        </Element>
        {weekDays.map(wD => (
          <td key={wD}>
            <Element display="flex" justifyContent="space-between">
              {left ? (
                left(wD)
              ) : (
                <Element textWeight="bold">
                  <span>{weekDayNames[wD]}</span>
                </Element>
              )}
              <Element>{right ? right(wD) : undefined}</Element>
            </Element>
          </td>
        ))}
      </tr>
    </>
  )
}
WeeksList.Header = Header
